/**
 * Created by Carsten Bühler
 * User: c.buehler on 23.10.2018
 * Copyright: xdot GmbH 2018
 */

import { AppContext } from 'plugin/liferay-widgets-react-web';
import { ActionTypes } from '../constants/Constants';

import { getTitleStore } from '../stores/StoreFactory';

const TitleStore = getTitleStore(AppContext);

const fetchMissingTitles = () => {
    let keys = TitleStore.filterNotRequested(Object.keys(missingTitles));
    missingTitles = null;
    if (keys.length > 0) {

        let l = 0;
        const idx = keys.findIndex(k => {
            l += k.length + 1;
            return l > 1024;
        });

        if (idx>=0){
            missingTitles = keys.slice(idx).reduce((accum, key) => {
                accum[key] = true;
                return accum;
            }, {});
            keys = keys.slice(0,idx);
            setTimeout(fetchMissingTitles, 0);
        }

        //Do XHR with Key http://localhost:8080/delegate/title-lookup?keys=GaugingStation-5,GaugingStation-3,Group-23418
        //On Result send them to the store => Component should render.
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                // Typical action to be performed when the document is ready:
                if (xhr.responseText){
                    AppContext.getDispatcher().dispatch({
                        type: ActionTypes.TITLES_UPDATE,
                        payload: {
                            xhr,
                            lookUpResult: JSON.parse(xhr.responseText)
                        }
                    });
                }
            }
        };
        xhr.open("GET", "/o/title/lookup?keys=" + keys.join(','), true);
        xhr.send();

        AppContext.getDispatcher().dispatch({
            type: ActionTypes.TITLES_REQUEST,
            payload: {
                keys,
                xhr
            }
        });
    }
};

let missingTitles = null;
export default {
    missingTitles: (keys) => {
        if (missingTitles == null) {
            missingTitles = {};
            setTimeout(fetchMissingTitles, 0);
        }
        for (const key of keys) {
            missingTitles[ key ] = true;
        }
    }
}


// WEBPACK FOOTER //
// ./js/actions/TitleActions.js